// Translations for UI strings that were previously hardcoded in Korean.
// Korean remains the canonical key; non-Korean languages fall back to English when a locale has no override.
const hardcodedCleanup = {
  en: {
  "+ 달성 조건 추가": "+ Add condition",
  "0으로 두면 금액 하한 제한을 사실상 두지 않습니다.": "Set to 0 to effectively disable the minimum amount limit.",
  "CASHIER_DEPOSIT 실제 자산 반영 완료 기준": "Based on completed CASHIER_DEPOSIT asset postings",
  "CRITICAL_REVIEW 거래입니다. DB 자산/원장/온체인 상태를 대조 확인한 뒤 처리하는 것이 맞습니까?": "This is a CRITICAL_REVIEW transaction. Have you reconciled the DB asset, ledger, and on-chain state before proceeding?",
  "Ctrl/⌘ 또는 Shift로 여러 그룹을 선택할 수 있습니다.": "Use Ctrl/⌘ or Shift to select multiple groups.",
  "DB 동적 설정": "Dynamic DB settings",
  "KST 1시간 단위": "1-hour intervals (KST)",
  "KST 기준": "KST",
  "OFF면 출금 시 해당 베팅 요구 원장을 검사하지 않습니다.": "When OFF, the withdrawal flow does not check the wagering-requirement ledger.",
  "TX / 단계": "TX / Stage",
  "{count}명": "{count} users",
  "{date} {hour}시": "{date} {hour}:00",
  "{date} 종료일 기준 · 유저 지갑 + 레이크백 + 착석 자산 / 제외 유저 미포함": "As of end of {date} · user wallet + rakeback + seated assets / excluded users omitted",
  "{date} 종료일 최종 보유량": "Final balance at end of {date}",
  "{hours}시간 {minutes}분 {seconds}초": "{hours}h {minutes}m {seconds}s",
  "{hour}시": "{hour}:00",
  "{metric} 시간대 그래프": "{metric} hourly chart",
  "{minutes}분 {seconds}초": "{minutes}m {seconds}s",
  "{seconds}초": "{seconds}s",
  "{user} / {amount} {asset} 거래를 승인(거래완료) 처리할까요?\n실제 자산/원장 처리까지 수행됩니다.": "Approve and complete the {user} / {amount} {asset} transaction?\nThis will also perform the actual asset and ledger processing.",
  "{user} 거래를 거절 처리할까요?\n출금의 경우 실행 이후 상태면 안전장치에 의해 거절이 차단될 수 있습니다.": "Reject the transaction for {user}?\nFor withdrawals, rejection may be blocked by safeguards after execution has started.",
  "{user} 거래에 관리자 취소를 요청할까요?\n브로드캐스트 전이면 즉시 취소/예약금 복구하고, 이미 체인 전송 가능성이 있으면 자동 환불하지 않고 검토 상태를 유지합니다.": "Request an admin cancellation for the {user} transaction?\nBefore broadcast it is cancelled immediately and reserved funds are restored. If an on-chain transfer may already exist, no automatic refund is made and the transaction remains under review.",
  "각 달성 조건마다 아래에서 별도 보상을 설정합니다. 조건별 보상은 서로 독립적으로 수령됩니다.": "Set a separate reward for each condition below. Rewards for each condition are claimed independently.",
  "값": "Value",
  "개별 보상 금액": "Reward amount",
  "갱신": "Updated",
  "갱신 중…": "Refreshing…",
  "거래시간": "Transaction time",
  "거절": "Reject",
  "검토 필요": "Review required",
  "게임 총 수수료": "Total game fees",
  "게임 테이블 착석 세션 평균": "Average seated game-table session",
  "결제 요청을 처리하지 못했습니다.": "Could not process the payment request.",
  "결제 정책 설정": "Payment policy settings",
  "결제 정책 저장에 실패했습니다.": "Failed to save the payment policy.",
  "결제 정책을 불러오지 못했습니다.": "Failed to load the payment policy.",
  "결제 정책이 즉시 적용되었습니다.": "The payment policy has been applied immediately.",
  "결제 처리 상태 메시지를 확인할 수 없습니다.": "The payment processing status message is unavailable.",
  "고정 디자인": "Fixed design",
  "공지 요청을 처리하지 못했습니다.": "Could not process the notice request.",
  "구분 / 상태": "Type / Status",
  "그래프 항목": "Chart metric",
  "금액 제한은 저장 이후 생성되는 신규 요청부터 적용됩니다. 베팅 배수를 바꿔도 이미 생성된 기존 유저의 요구 베팅액은 소급 재계산하지 않고, 이후 확정되는 입금부터 새 배수가 적용됩니다.": "Amount limits apply to new requests created after saving. Changing the wagering multiplier does not recalculate existing users retroactively; the new multiplier applies to deposits confirmed afterward.",
  "금액은 0 이상의 숫자로 입력하고 소수점은 2자리까지만 사용할 수 있습니다.": "Enter an amount of 0 or more with up to two decimal places.",
  "기간 통계는 날짜별 최종 집계값만 합산하여 조회합니다.": "Range statistics are calculated by summing the final aggregate for each date.",
  "기본은 오늘 하루이며, 필요하면 시작일~종료일 기간 통계를 조회할 수 있습니다.": "The default view is today. You can also query statistics for a start-to-end date range.",
  "기존 일별/기간 통계 구조는 그대로 유지합니다. 과거 영구 원본이 남아 있는 금액·가입·최초입금 지표는 최근 90일까지 hourly 전용 cursor로 1회 백필하며, 접속/체류/플레이 시간은 시간대 기능 적용 이후 데이터부터 집계됩니다.": "The existing daily/range statistics structure is preserved. Amount, signup, and first-deposit metrics with durable historical source data are backfilled once for up to the last 90 days using the hourly cursor; connection, stay, and play-time metrics are collected from the time hourly analytics was enabled.",
  "끝": "End",
  "누적 베팅 금액": "Cumulative bet amount",
  "누적 실제 입금액": "Cumulative actual deposit amount",
  "다음 날짜": "Next date",
  "달성 조건": "Conditions",
  "달성 조건 #{number}의 목표값을 입력해 주세요.": "Enter a target value for condition #{number}.",
  "달성 조건 #{number}의 보상 금액을 0보다 크게 입력해 주세요.": "Enter a reward amount greater than 0 for condition #{number}.",
  "달성 조건 #{number}의 테이블 그룹을 1개 이상 선택해 주세요.": "Select at least one table group for condition #{number}.",
  "달성 조건 #{number}의 행동이 올바르지 않습니다.": "The action for condition #{number} is invalid.",
  "달성 조건 #{number}의 횟수는 정수로 입력해 주세요.": "Enter a whole-number count for condition #{number}.",
  "달성 조건을 1개 이상 추가해 주세요.": "Add at least one condition.",
  "대상 / 테이블 그룹 (복수 선택)": "Target / Table group (multiple selection)",
  "더보기": "More",
  "데일리 미션 금액 획득량": "Daily mission rewards earned",
  "데일리 미션 획득량": "Daily mission rewards",
  "등록 지갑 주소": "Registered wallet address",
  "등록된 이벤트 없음": "No event registered",
  "등록된 테이블 그룹이 없습니다. 테이블 관리에서 그룹을 먼저 확인해 주세요.": "No table groups are registered. Check the groups in Table Management first.",
  "라운지 거래 수수료": "Lounge transaction fees",
  "라운지 결제 paid 기록 기준": "Based on paid lounge-payment records",
  "라운지 요청을 처리하지 못했습니다.": "Could not process the lounge request.",
  "라운지 포인트": "Lounge points",
  "라운지 포인트 획득량": "Lounge points earned",
  "레벨링 미션 총 금액 획득량": "Total leveling mission rewards earned",
  "레벨링 미션 획득량": "Leveling mission rewards",
  "로비 접속 세션 평균": "Average lobby session",
  "로비 총 체류시간": "Total lobby time",
  "리버 쇼다운 횟수": "River showdown count",
  "마지막 변경 관리자": "Last modified by",
  "마지막 변경 시각": "Last modified",
  "마지막 통계 갱신": "Last statistics update",
  "모든 유저 라운지 포인트 보유량": "Total lounge points held by all users",
  "모든 테이블 테이블 미션 총금액 획득량": "Total table mission rewards across all tables",
  "목록 조회 실패": "Failed to load the list",
  "목표 Asset": "Target asset",
  "문제-보류": "Problem hold",
  "미션 조건과 보상만 설정합니다. 유저 팝업은 유저클라이언트에 최적화된 고정 디자인으로 표시됩니다.": "Configure only the mission conditions and rewards. The user popup uses a fixed design optimized for the user client.",
  "배": "x",
  "배정 지갑 / 브릿지": "Assigned wallet / Bridge",
  "베팅금액 달성": "Reach bet amount",
  "변경 즉시 현재 자산 집계가 다시 계산됩니다.": "The current asset aggregate is recalculated immediately after a change.",
  "보류": "Hold",
  "보류/검토": "Hold / Review",
  "분": "min",
  "생성된 팝업 URL": "Generated popup URL",
  "생애 최초 입금이 해당 날짜인 유저": "Users whose lifetime first deposit occurred on this date",
  "생애 최초 입금일이 선택 기간에 포함된 유저 합계": "Total users whose lifetime first-deposit date falls within the selected range",
  "서버 요청을 처리하지 못했습니다.": "Could not process the server request.",
  "선택 기간 CASHIER_DEPOSIT 실제 자산 반영 완료 합계": "Total completed CASHIER_DEPOSIT asset postings in the selected range",
  "선택 기간 · KST 기준": "Selected range · KST",
  "선택 기간 라운지 결제 paid 기록 합계": "Total paid lounge-payment records in the selected range",
  "선택 기간 성공 처리된 출금 합계": "Total successful withdrawals in the selected range",
  "선택 기간 신규 가입자 합계": "Total new signups in the selected range",
  "선택 기간 실제 에이전트 라인 지급 완료 합계": "Total completed actual agent-line payouts in the selected range",
  "선택 기간 유저에게 실제 지급된 이벤트/레이크백 수수료 합계": "Total event/rakeback fee rewards actually paid to users in the selected range",
  "선택 기간 일별 로비 접속 고유 유저 수의 합계": "Sum of daily unique lobby users in the selected range",
  "선택 기간 일별 성공 입금 고유 유저 수의 합계": "Sum of daily unique successful depositors in the selected range",
  "선택 기간 전체 게임 테이블 착석 세션 가중평균": "Weighted average of all seated game-table sessions in the selected range",
  "선택 기간 전체 로비 접속 세션 가중평균": "Weighted average of all lobby sessions in the selected range",
  "선택한 항목의 시간대 값이 아직 없습니다.": "No hourly values are available yet for the selected metric.",
  "설정 저장": "Save settings",
  "성공 처리된 출금 기준": "Based on successfully processed withdrawals",
  "쇼다운 도달 횟수": "Showdown count",
  "승리 횟수": "Win count",
  "승리는 폴드승 포함 · 쇼다운은 실제 SHOWDOWN이면서 리버를 거친 경우만 인정 · 충전은 Cashier에서 FINAL_DONE으로 확정되어 CASHIER_DEPOSIT 원장에 기록된 실제 입금액만 인정(테이블 Buy-in/리바이 제외) · 베팅은 블라인드를 포함한 실제 핸드 총 투입액 기준입니다.": "Wins include fold wins · Showdowns count only actual SHOWDOWN hands that reached the river · Deposits count only actual deposits confirmed as FINAL_DONE by Cashier and recorded in the CASHIER_DEPOSIT ledger (table buy-ins/rebuys excluded) · Bets are based on the actual total amount committed in the hand, including blinds.",
  "승인": "Approve",
  "시간당 평균": "Hourly average",
  "시간대 그래프는 한 번에 최대 90일까지 조회할 수 있습니다.": "The hourly chart can query up to 90 days at a time.",
  "시간대 분석": "Hourly analysis",
  "시간대 저장 데이터를 생성 중입니다.": "Hourly stored data is being generated.",
  "시간대 통계를 불러오는 중…": "Loading hourly statistics…",
  "시간대 통계를 불러오지 못했습니다.": "Failed to load hourly statistics.",
  "시간마다": "hours",
  "시작 날짜는 끝 날짜보다 늦을 수 없습니다.": "The start date cannot be later than the end date.",
  "시작 날짜와 끝 날짜를 모두 선택해 주세요.": "Select both a start date and an end date.",
  "신규 유저 가입 수": "New user signups",
  "신규 유저 수": "New users",
  "신청 금액": "Requested amount",
  "실시간 결제상황": "Live payment status",
  "실제 에이전트 라인 지급 완료 기준": "Based on completed actual agent-line payouts",
  "아래 URL을 복사하세요.": "Copy the URL below.",
  "열린 상태 전체": "All open statuses",
  "예: 10": "e.g. 10",
  "예: 1000": "e.g. 1000",
  "예: 2500": "e.g. 2500",
  "예: 5": "e.g. 5",
  "예: 500": "e.g. 500",
  "예시: 최소 입금 {minimum} USDT / 베팅 배수 {multiplier}배 설정 시, 100 USDT 입금 완료 후 요구 베팅액은 {required} USDT입니다.": "Example: with a minimum deposit of {minimum} USDT and a wagering multiplier of {multiplier}x, a completed 100 USDT deposit creates a wagering requirement of {required} USDT.",
  "오늘": "Today",
  "오늘 이후 날짜는 선택할 수 없습니다.": "You cannot select a date after today.",
  "오늘의 미션": "Daily mission",
  "오늘의 미션 설정": "Daily mission settings",
  "오늘의 미션 설정을 불러오는 중...": "Loading daily mission settings...",
  "오늘의 미션 설정을 불러오지 못했습니다.": "Failed to load daily mission settings.",
  "오늘의 미션 저장에 실패했습니다.": "Failed to save the daily mission.",
  "오늘의 미션을 저장했습니다. 새 이벤트 회차로 진행도가 분리됩니다.": "The daily mission has been saved. Progress is separated into a new event cycle.",
  "오늘의 미션을 중지했습니다.": "The daily mission has been stopped.",
  "완료 확인 중": "Awaiting completion confirmation",
  "요구 배수": "Required multiplier",
  "요청은 처리되었지만 확인이 필요한 항목이 있습니다.": "The request was processed, but some items require review.",
  "운영 대시보드": "Operations dashboard",
  "운영 통계를 불러오지 못했습니다.": "Failed to load operations statistics.",
  "유저 목록을 불러오지 못했습니다.": "Failed to load the user list.",
  "유저 이벤트 수수료 획득량": "User event fee rewards earned",
  "유저 지갑 + 레이크백 잔액 + 현재 테이블 착석 자산 / 제외 유저 미포함": "User wallet + rakeback balance + currently seated table assets / excluded users omitted",
  "유저 팝업 표시": "User popup display",
  "유저(유저코드) / 닉네임": "User (user code) / Nickname",
  "유저에게 실제 지급된 이벤트/레이크백 수수료": "Event/rakeback fee rewards actually paid to users",
  "유저코드 / 아이디 / 닉네임 검색": "Search user code / ID / nickname",
  "이 거래를 보류 상태로 잠글까요?\n이미 시작된 온체인 송금 자체를 중단하는 기능은 아닙니다.": "Lock this transaction in hold status?\nThis does not stop an on-chain transfer that has already started.",
  "이 출금은 온체인 전송 및 브로드캐스트가 없음을 확인했습니까? 확인되지 않았다면 취소하세요.": "Have you confirmed that this withdrawal has no on-chain transfer or broadcast? Cancel if this has not been verified.",
  "이메일 관리": "Email management",
  "이벤트 중지": "Stop event",
  "이벤트 중지에 실패했습니다.": "Failed to stop the event.",
  "이전 날짜": "Previous date",
  "일별 최종값 구조는 그대로 유지하고, 같은 cursor batch에서 KST 시간별 집계값을 함께 저장합니다.": "The daily final-value structure is preserved while KST hourly aggregates are stored in the same cursor batch.",
  "입금": "Deposit",
  "입금 완료 시 입금액 × 배수만큼 베팅 요구액이 생성됩니다.": "When a deposit is completed, a wagering requirement equal to deposit amount × multiplier is created.",
  "입금 유저 수": "Depositing users",
  "입금 제한": "Deposit limit",
  "입금(충전) 금액": "Deposit amount",
  "입금·출금 금액 제한과 입금액 기준 출금 전 베팅 요구 배수를 변경합니다. 저장 즉시 신규 결제 처리에 적용됩니다.": "Change deposit/withdrawal amount limits and the pre-withdrawal wagering multiplier based on the deposit amount. Saved changes apply immediately to new payment processing.",
  "입금액 기준 베팅 요구": "Deposit-based wagering requirement",
  "입출금 전체": "All deposits/withdrawals",
  "자산 금액 달성": "Reach asset amount",
  "자산 즉시 갱신": "Refresh assets now",
  "자산 집계 제외 유저 설정": "Asset aggregation exclusions",
  "자산 집계를 새로고침하지 못했습니다.": "Failed to refresh the asset aggregate.",
  "자산 최종 집계": "Final asset aggregate",
  "저장 / 새 회차 등록": "Save / Start new cycle",
  "저장 데이터 시작": "Stored data starts",
  "저장 시점을 기준으로 설정 시간마다 Redis 진행도 회차가 자동 변경됩니다.": "The Redis progress cycle changes automatically at the configured interval, measured from the save time.",
  "저장 후 자동 생성됩니다.": "Generated automatically after saving.",
  "적용 기준": "Application rules",
  "전체 유저 자산 보유량": "Total user assets held",
  "전체 잠재 보상 합계": "Total potential rewards",
  "접속자 수": "Connected users",
  "정책 소스": "Policy source",
  "제외": "Exclude",
  "제외 설정을 저장하지 못했습니다.": "Failed to save the exclusion setting.",
  "제외 유저 설정": "Excluded-user settings",
  "종료일 자산 최종 집계": "End-date final asset aggregate",
  "지갑+레이크백": "Wallet + Rakeback",
  "진행 중": "In progress",
  "진행 중 거래부터 보류·검토 필요 거래까지 3초 간격으로 자동 갱신합니다.": "Automatically refreshes every 3 seconds, from in-progress transactions to held and review-required transactions.",
  "집계 규칙": "Counting rules",
  "처리 실패": "Processing failed",
  "처리가 완료되었습니다.": "Processing completed.",
  "처리중": "Processing",
  "체크한 유저는 전체 유저 자산 보유량 집계에서만 제외됩니다. 라운지 포인트 통계에는 영향을 주지 않습니다.": "Checked users are excluded only from the total user asset aggregate. Lounge point statistics are not affected.",
  "초기화 시간": "Reset interval",
  "초기화 시간은 1~720시간의 정수로 입력해 주세요.": "Enter the reset interval as an integer from 1 to 720 hours.",
  "총 라운지 거래 수수료": "Total lounge transaction fees",
  "총 유저 라운지 포인트 획득량": "Total lounge points earned by users",
  "총 유저 이벤트 수수료 획득량": "Total user event fee rewards earned",
  "총 입금(충전) 금액": "Total deposit amount",
  "총 출금(환전) 금액": "Total withdrawal amount",
  "총 플레이시간": "Total play time",
  "최고": "Peak",
  "최대 출금 제한은 필요할 때만 켤 수 있습니다.": "Enable the maximum withdrawal limit only when needed.",
  "최대 출금 제한을 사용하려면 0보다 큰 금액을 입력하세요.": "Enter an amount greater than 0 to enable the maximum withdrawal limit.",
  "최대 출금금액 제한": "Maximum withdrawal limit",
  "최대 출금금액 형식이 올바르지 않습니다.": "The maximum withdrawal amount format is invalid.",
  "최대 출금금액은 최소 출금금액보다 작을 수 없습니다.": "The maximum withdrawal amount cannot be less than the minimum withdrawal amount.",
  "최소 입금금액": "Minimum deposit amount",
  "최소 출금금액": "Minimum withdrawal amount",
  "최초 입금 유저 수": "First-time depositors",
  "출금": "Withdrawal",
  "출금 금액 제한": "Withdrawal amount limits",
  "출금 전 베팅 기준": "Pre-withdrawal wagering requirement",
  "출금 전 베팅 요구 배수는 1~100 사이 정수로 입력하세요.": "Enter the pre-withdrawal wagering multiplier as an integer from 1 to 100.",
  "출금 환불": "Withdrawal refund",
  "출금(환전) 금액": "Withdrawal amount",
  "충전 (Deposit / NL 무관)": "Deposit (all NL levels)",
  "충전 (Deposit)": "Deposit",
  "충전유저 수": "Depositing users",
  "테이블 그룹 목록을 불러오지 못했습니다.": "Failed to load the table-group list.",
  "테이블 미션 획득량": "Table mission rewards",
  "통계 기간 선택 방식": "Statistics period selection",
  "통계 기록 서버 연결 상태를 확인해 주세요. 일부 writer heartbeat가 감지되지 않았습니다.": "Check the analytics writer server connection. Some writer heartbeats were not detected.",
  "통계는 날짜별 최종 집계 저장소에서 조회합니다.": "Statistics are read from the daily final-aggregate store.",
  "통계를 불러오는 중…": "Loading statistics…",
  "팝업 HTML/CSS/이미지 업로드 기능은 사용하지 않습니다. 위에서 등록한 달성 조건, 복수 테이블 그룹, 목표값, 조건별 보상 금액과 유저의 실시간 진행도가 유저클라이언트 고정 팝업에 자동 표시됩니다.": "Popup HTML/CSS/image uploads are not used. The conditions, multiple table groups, targets, per-condition rewards, and each user's real-time progress are shown automatically in the fixed user-client popup.",
  "팝업 URL을 복사했습니다.": "Popup URL copied.",
  "평균 체류시간": "Average stay time",
  "평균 플레이 시간": "Average play time",
  "표시할 통계가 없습니다.": "No statistics to display.",
  "하루": "Day",
  "합계": "Total",
  "항목": "Metric",
  "해당 날짜 로비에 접속한 고유 유저": "Unique users who entered the lobby on this date",
  "해당 날짜 성공 입금 고유 유저": "Unique users with successful deposits on this date",
  "행동": "Action",
  "현재 오늘의 미션을 중지하시겠습니까?": "Stop the current daily mission?",
  "현재 진행/검토 중인 결제가 없습니다.": "There are no payments currently in progress or under review.",
  "현재 표시": "Currently shown",
  "환경변수 기본값": "Environment-variable defaults",
  "상금 방식 입력: auto = 기존 자동계산 / manual = 순위별 수동설정": "Enter prize mode: auto = existing automatic calculation / manual = manual prize amounts by rank",
  "상금 방식은 auto 또는 manual 로 입력해 주세요.": "Enter auto or manual for the prize mode.",
  "수동 상금을 지급할 순위 수를 입력하세요. (예: 2 = 1등, 2등)": "Enter the number of ranks to receive manual prizes. (Example: 2 = 1st and 2nd place)",
  "순위 수는 1~50 사이 정수로 입력해 주세요.": "Enter a whole number of ranks between 1 and 50.",
  "{rank}등 플레이어 당첨 금액을 입력하세요.": "Enter the player prize amount for rank {rank}.",
  "플레이어 당첨 금액은 0보다 커야 합니다.": "The player prize amount must be greater than 0.",
  "{rank}등 에이전트 몫을 입력하세요. 0이면 지급 없음.": "Enter the agent share for rank {rank}. Enter 0 for no payout.",
  "에이전트 몫은 0 이상의 숫자여야 합니다.": "The agent share must be 0 or greater.",
  "수동 설정": "Manual settings",
  "플레이어 수동 상금 합계:": "Total manual player prizes:",
  "에이전트 수동 상금 합계:": "Total manual agent prizes:",
  "총 수동 상금:": "Total manual prizes:",
  "미리보기 내용이 없습니다.": "No preview content is available.",
  "첨부파일 있음": "Has attachment",
  "답장 작성": "Write reply",
  "새 메일 작성": "Compose new email",
  "받는 사람": "Recipient",
  "여러 주소는 쉼표로 구분할 수 있습니다.": "Separate multiple addresses with commas.",
  "내용": "Message",
  "메일 내용을 입력하세요.": "Enter the email message.",
  "발송 중...": "Sending...",
  "메일 발송": "Send email",
  "Microsoft 365 메일함에 연결하지 못했습니다.": "Could not connect to the Microsoft 365 mailbox.",
  "종료 날짜는 시작 날짜보다 빠를 수 없습니다.": "The end date cannot be earlier than the start date.",
  "메일 내용을 불러오지 못했습니다.": "Could not load the email message.",
  "선택한 메일을 삭제하시겠습니까?": "Delete the selected email?",
  "메일 삭제에 실패했습니다.": "Failed to delete the email.",
  "메일 내용을 입력해 주세요.": "Enter the email message.",
  "받는 사람과 제목을 입력해 주세요.": "Enter the recipient and subject.",
  "메일 발송을 요청했습니다.": "The email has been queued for sending.",
  "메일 발송에 실패했습니다.": "Failed to send the email.",
  "Microsoft 365 메일함 연결 오류": "Microsoft 365 mailbox connection error",
  "새 메일": "New email",
  "받은편지함": "Inbox",
  "보낸편지함": "Sent",
  "연결됨": "Connected",
  "연결 확인 중": "Checking connection",
  "새로고침 중...": "Refreshing...",
  "메일함 새로고침": "Refresh mailbox",
  "건 표시": "items shown",
  "시작 날짜": "Start date",
  "종료 날짜": "End date",
  "날짜 조회": "Search by date",
  "메일을 불러오는 중...": "Loading emails...",
  "표시할 메일이 없습니다.": "No emails to display.",
  "메일 내용을 불러오는 중...": "Loading email message...",
  "보낸 사람": "Sender",
  "시간": "Time",
  "답장": "Reply",
  "삭제 중...": "Deleting...",
  "메일 본문이 없습니다.": "This email has no message body.",
  "첨부파일이 포함된 메일입니다. 현재 어드민 UI에서는 첨부 여부만 표시합니다.": "This email includes attachments. The current admin UI only shows whether attachments are present.",
  "메일을 선택하세요": "Select an email",
  "받은 메일을 확인하거나 새 메일을 작성할 수 있습니다.": "Review received emails or compose a new message.",
  "게시글 URL": "Post URL",
  "라운지 게시글 URL": "Lounge post URL",
  "복사됨": "Copied",
  "본문 에디터": "Content editor",
  "일반 블로그처럼 큰 편집 영역에서 글을 작성하고, 상단 도구로 텍스트 스타일·링크·이미지를 넣을 수 있습니다.": "Write in a large editor like a standard blog, and use the toolbar to add text styles, links, and images.",
  "기존 텍스트/이미지 블록 형식으로 자동 저장됩니다.": "Content is automatically saved in the existing text/image block format.",
  "텍스트 종류": "Text type",
  "선택한 텍스트 크기": "Selected text size",
  "먼저 텍스트를 선택하세요": "Select text first",
  "선택한 텍스트 굵게": "Bold selected text",
  "선택한 텍스트 기울임": "Italicize selected text",
  "선택한 텍스트 밑줄": "Underline selected text",
  "선택한 텍스트 색상": "Selected text color",
  "선택한 텍스트에 링크 넣기": "Add link to selected text",
  "선택한 텍스트 링크 제거": "Remove link from selected text",
  "현재 커서 위치에 이미지 첨부": "Insert image at the current cursor position",
  "링크": "Link",
  "굵기·크기·색상·링크는 드래그로 선택한 글자에만 적용됩니다. Enter로 줄을 바꾸며 계속 작성할 수 있습니다.": "Bold, size, color, and link changes apply only to the text you select by dragging. Press Enter to continue on a new line.",
  "가로 표시영역": "Display width",
  "높이 표시영역": "Display height",
  "가로·높이는 이미지 크기를 바꾸지 않고 보이는 영역만 조절합니다. 영역 밖 이미지는 중앙 기준으로 잘립니다.": "Width and height change only the visible viewport, not the image size. Content outside the viewport is cropped from the center.",
  "이미지 삭제": "Delete image",
  "support@nightpokerclub.com Microsoft 365 메일함 · 유저/마케팅 이메일 발송": "support@nightpokerclub.com Microsoft 365 mailbox · User/marketing email delivery",
  "메일함": "Mailbox",
  "유저/마케팅 발송": "User/marketing delivery",
}
};

export default hardcodedCleanup;
